import React from "react";
import { NoRecords } from "../../common/components/NoRecords";

export const NoActiveEmployee = () => {
  return (
    <NoRecords
      message={
        "Usuário não está associado com um funcionário, selecione um funcionário que você tenha acesso no menu superior ou contate o administrador do sistema."
      }
    />
  );
};
